import { BaseDto } from "@models/base/baseDto.model";

export class TipoServicio extends BaseDto{
}
